module.exports = __webpack_public_path__ + "static/media/1.788b059d.png";